import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchStoreProductsAPI(filters, data ) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/store/products/all?${getQueryString(filters)}`, data);
}


//get Store product by Id
export async function fetchStoreProductDetailsAPI({productId, storeId}) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/store/products/${storeId}?productId=${productId}`);
}

//delete Store product
export async function deleteStoreProductAPI({productId, storeId}) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`api/v1/admin/store/products/delete`, {productId, storeId})
}

//add store product
export async function addStoreProductFromMasterCatalogAPI(data ,storeId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`api/v1/admin/store/products`, { products: data, storeId })
}

//get store product batch by ID
export async function getStoreProductBatchAPI({productId, storeId}) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/store/products/batches/${storeId}?productId=${productId}`)
}